function parseVideoUrl(url) {
    let parsed;
    try {
        parsed = new URL(url);
    }
    catch {
        return null;
    }
    const youtubeVideoId = extractYoutubeVideoId(parsed);
    if (youtubeVideoId !== null) {
        return {
            vendor: 'youtube',
            videoId: youtubeVideoId,
            embedUrl: `https://www.youtube.com/embed/${youtubeVideoId}`,
            thumbnailUrl: `https://img.youtube.com/vi/${youtubeVideoId}/maxresdefault.jpg`,
        };
    }
    return { vendor: 'internal', url };
}
function extractYoutubeVideoId(parsed) {
    const { hostname, pathname, searchParams } = parsed;
    if (hostname === 'youtu.be') {
        const id = pathname.slice(1);
        return id.length > 0 ? id : null;
    }
    if (hostname === 'www.youtube.com' || hostname === 'youtube.com') {
        if (pathname === '/watch') {
            const id = searchParams.get('v');
            return id && id.length > 0 ? id : null;
        }
        const embedMatch = pathname.match(/^\/embed\/([^/?]+)/);
        if (embedMatch) {
            return embedMatch[1];
        }
    }
    return null;
}

export { parseVideoUrl };
//# sourceMappingURL=parseVideoUrl.js.map
